import { Component, Input } from '@angular/core';
import { ContentModel } from 'app/models/content';

@Component({
  selector: 'site-listPageContentBoxes',
  templateUrl: './listPageContentBoxes.component.html',
  styleUrls: ['./listPageContentBoxes.component.css']
})
export class ListPageContentBoxesComponent {
  @Input()
  routingLink: String;

  @Input()
  filmTitleOne: String;
  @Input()
  filmTitleTwo: String;
  @Input()
  filmTitleThree: String;
  @Input()
  filmTitleFour: String;
  @Input()
  filmTitleFive: String;

  @Input()
  content1Image: String;
  @Input()
  content2Image: String;
  @Input()
  content3Image: String;
  @Input()
  content4Image: String;
  @Input()
  content5Image: String;

  @Input()
  contentList: ContentModel[];
}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/listPageContentBoxes/listPageContentBoxes.component.ts